<template>
  <div class="form-group row">
    <div class="col-md-12">
      <Forms
        ref="frmGroup"
        :title="'CONFIGURAÇÃO MODULOS'"
        :showClearButton="true"
        :showSaveButton="true"
        v-on:Save="submitFile"
      >
        <table class="table table-hover table-sm">
          <thead>
            <tr class="table-header-custom">
              <th>MODULO</th>
              <th>STATUS</th>
              <th>DATA DE ATUALIZAÇÃO</th>
              <th>
                <input
                  type="checkbox"
                  v-model="selectAll"
                  @change="toggleAll"
                />
                Ativar/Desativar
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="5">
                <span
                  @click="toggleAssociadoDropdown"
                  class="clickDrop"
                >
                  Associados
                  <i
                    :class="
                      dropdownOpen ? 'fa fa-chevron-up' : 'fa fa-chevron-down'
                    "
                  ></i>
                </span>
                <div
                  v-if="dropdownOpen"
                  class="dropdown-content"
                >
                  <table class="table table-hover table-sm">
                    <tbody>
                      <tr
                        v-for="(label, key) in associatedToggles"
                        :key="key"
                      >
                        <td class="modulos">{{ label }}</td>
                        <td>
                          <span
                            :class="
                              settings[key] ? 'text-success' : 'text-danger'
                            "
                          >
                            {{ settings[key] ? 'Ativo' : 'Inativo' }}
                          </span>
                        </td>
                        <td>
                          {{
                            formatDateTimeForms(settings[key + 'UpdatedDate'])
                          }}
                        </td>
                        <td>
                          <ToogleSwitch v-model="settings[key]" />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </td>
            </tr>

            <tr
              v-for="(label, key) in nonAssociatedToggles"
              :key="key"
            >
              <td>{{ label }}</td>
              <td>
                <span :class="settings[key] ? 'text-success' : 'text-danger'">
                  {{ settings[key] ? 'Ativo' : 'Inativo' }}
                </span>
              </td>
              <td>{{ formatDateTimeForms(settings[key + 'UpdatedDate']) }}</td>
              <td>
                <ToogleSwitch v-model="settings[key]" />
              </td>
            </tr>
          </tbody>
        </table>
      </Forms>
    </div>
  </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast } from '@/shared/utils/UIHelper'
import ModulesRepository from '@/shared/http/repositories/access/modulos'
import ToogleSwitch from '@/components/UI/toogleSwitch/toogleSwitch.vue'

export default {
  name: 'Environment',
  mixins: [ActionsForm],
  data () {
    return {
      toggles: {
        hasAssociado: 'Associado',
        hasAssociadoAnotacoesNegativas: 'Anotações Negativas',
        hasAssociadoBensAssociados: 'Bens Associados',
        hasAssociadoCaptacaoRemuneradaDiaria: 'Captação Remunerada Diária',
        hasAssociadoCartaoCredito: 'Cartão de Crédito',
        hasAssociadoCarteiraConsorcio: 'Carteira Consórcio',
        hasAssociadoCarteiraSeguros: 'Carteira Seguros',
        hasAssociadoContaCorrente: 'Conta Corrente',
        hasAssociadoContaPoupanca: 'Conta Poupança',
        hasAssociadoContratosVigentes: 'Contratos Vigentes',
        hasAssociadoEndividamento: 'Endividamento',
        hasAssociadoEndividamentoSfn: 'Endividamento SFN',
        hasAssociadoGarantiaOperacoes: 'Garantia Operações',
        hasAssociadoGrupoEconomico: 'Grupo Econômico',
        hasAssociadoMargemContribuicao: 'Margem Contribuição',
        hasAssociadoMatricula: 'Matrícula',
        hasAssociadoMovimentacaoDiariaConta: 'Movimentação Diária Conta',
        hasAssociadoPix: 'Pix',
        hasAssociadoRisco: 'Risco',
        hasAssociadoSaldoMedioCaptacao: 'Saldo Médio Captação',
        hasAssociadoSaldoMedioCco: 'Saldo Médio CCO',
        hasAssociadoUtilizacaoProdutos: 'Utilização Produtos',
        hasAssociadoContatos: 'Contatos',
        hasAssociadoInformacoesAssociado: 'Informações do Associado',
        hasAssociadoInformacoesPessoais: 'Informações Pessoais',
        hasAssociadoLogradouro: 'Logradouro',
        hasAssociadoPessoasRelacionadas: 'Pessoas Relacionadas',
        hasCampanha: 'Campanha',
        hasCobranca: 'Cobrança',
        hasCrm: 'Crm',
        hasAjuizamento: 'Ajuizamento',
        hasImportacao: 'Importação',
        hasListaInteligente: 'Lista Inteligente',
        hasRelatorios: 'Relatórios',
        hasVisitas: 'Visitas'
      },
      settings: {},
      dropdownOpen: false,
      selectAll: false,
      selectAllAssociados: false
    }
  },
  computed: {
    associatedToggles () {
      return Object.keys(this.toggles).reduce((acc, key) => {
        if (key.includes('hasAssociado')) {
          acc[key] = this.toggles[key]
        }
        return acc
      }, {})
    },
    nonAssociatedToggles () {
      return Object.keys(this.toggles).reduce((acc, key) => {
        if (!key.includes('hasAssociado')) {
          acc[key] = this.toggles[key]
        }
        return acc
      }, {})
    }
  },
  components: {
    ToogleSwitch
  },
  created () {
    this.onLoad()
  },
  methods: {
    onLoad () {
      ModulesRepository.GetAll()
        .then((res) => {
          this.settings = Object.keys(res.data).reduce((acc, key) => {
            if (key.includes('has')) {
              acc[key] = res.data[key]
            }
            if (key.includes('UpdatedDate')) {
              const updatedKey = key.replace('UpdatedDate', '')
              acc[updatedKey + 'UpdatedDate'] = res.data[key]
            }
            return acc
          }, {})
        })
        .catch((err) => console.error(err))
    },
    submitFile () {
      ModulesRepository.Update(this.settings)
        .then(() => {
          toast.success('Ambiente alterado')
          this.$router.replace({ name: 'PaginaInicial' })
          this.$router.go(0)
        })
        .catch(this.onException)
    },
    clearInputs () {},
    toggleAll () {
      const value = this.selectAll

      Object.keys(this.nonAssociatedToggles).forEach((key) => {
        this.settings[key] = value
      })

      Object.keys(this.associatedToggles).forEach((key) => {
        this.settings[key] = value
      })

      this.selectAllAssociados = value
    },

    toggleAssociados () {
      const value = this.selectAllAssociados

      Object.keys(this.associatedToggles).forEach((key) => {
        this.settings[key] = value
      })
    },

    toggleAssociadoDropdown (event) {
      event.preventDefault()
      event.stopPropagation()
      this.dropdownOpen = !this.dropdownOpen
    },

    formatDateTimeForms (obj) {
      if (!obj) return ''
      const [date, time] = obj.split('T')
      const [year, month, day] = date.split('-')
      const formattedDate = `${day}/${month}/${year}`
      const [hour, minute, second] = time.split(':')
      const formattedTime = `${hour}:${minute}:${second.split('.')[0]}`
      return `${formattedDate} ${formattedTime}`
    }
  }
}
</script>

<style scoped>
.table {
  position: relative;
}

.table-header-custom {
  position: sticky;
  top: 0;
  background-color: #04a791 !important;
  color: white;
}

.clickDrop {
  cursor: pointer;
}

.dropdown-content .table {
  margin-bottom: 0;
}
.table-container {
  display: flex;
  flex-direction: column;
}

.table-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.dropdown-content {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  max-height: 200px;
  overflow-y: auto;
}
.modulos {
  max-width: 70px;
  min-width: 70px;
}
</style>



// WEBPACK FOOTER //
// src/views/private/configurations/modules/components/list/modulesList.vue